module.exports = __webpack_public_path__ + "img/ptofile-photo-transparent.ce08e712.png";